import React from 'react';
import './PhoneMockup.css';

const PhoneMockup = ({ screenshot = "/images/onetimer-screenshot.png", alt = "OneTimer App Screenshot" }) => {
  return (
    <div className="phone-mockup">
      <div className="phone-frame">
        <div className="phone-notch"></div>
        <div className="phone-screen">
          <div className="phone-screen-content">
            <img src={screenshot} alt={alt} />
          </div>
        </div>
        <div className="phone-home-indicator"></div>
      </div>
      
      {/* Side buttons */}
      <div className="phone-button-left"></div>
      <div className="phone-button-right-1"></div>
      <div className="phone-button-right-2"></div>
      <div className="phone-button-right-3"></div>
    </div>
  );
};

export default PhoneMockup;